<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="title">
                                <b>Termos de Uso</b>

                                <i class="fa fa-user-secret" style="float:right;margin-top:6px;font-size:21px;"></i>
                            </span>

                            <hr class="m-t-md">
                        </div>
                        
                        <div class="col-md-12">
                            <div class="form-group">
                                <vue-editor id="description" v-model="useTerms.description"></vue-editor>
                            </div>
                        </div>

                        <hr class="m-t-lg">

                        <div class="block text-right">
                            <router-link to="/admin" class="btn btn-info m-r-sm m-b-sm">
                                <i class="fa fa-arrow-left"></i> Voltar
                            </router-link>

                            <button class="btn btn-primary m-r-sm m-b-sm" @click="save">
                                Salvar <i class="fa fa-save"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor';

    export default {
        data: function () {
            return{
                useTerms: {
                    description: ''
                }
            }
        },
        components: {
            VueEditor
        },
        methods: {
            getPrivacyTerms: function () {
                const self = this;
                const api = self.$store.state.api + 'useTerms/' + 1;

                self.$http
                    .get(api)
                    .then((response) => {
                        self.useTerms = response.data;
                    })
                    .catch((error) => {
                        self.$message(null, 'Não foi possível buscar as informações referente aos Termos de Uso', 'error');
                    });
            },
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'useTerms/' + 1;

                self.$http
                    .put(api, self.useTerms)
                    .then((response) => {
                        self.$message(null, 'Termos de Privacidade atualizado com sucesso', 'success');
                    })
                    .catch((error) => {
                        self.$error(error);
                    });
            }
        },
        mounted: function () {
            this.getPrivacyTerms();
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/UseTerms/Index.vue